export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11168.880168d7.jpg";